export const fuzzyMatch = (pattern: string, str: string) => {
    pattern = '.*' + pattern.split('').join('.*') + '.*';
    const re = new RegExp(pattern, 'i');
    return re.test(str);
};
